import {
  ListTagsRequest,
  ListTagsResponse,
} from 'client/@types/cbinsights/cbitagservice/cbitagservice';
import { request } from 'client/modules/common/utils/request';

export const listTags = (
  req: Partial<ListTagsRequest>
): Promise<ListTagsResponse> => {
  return request({
    url: '/service/cbitagservice/ListTags',
    body: {
      ...req,
    },
  }).then((r): ListTagsResponse => r.body);
};
